import React, { useEffect, useState } from "react";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { formatDate } from "../../../../utils/utils";
import { Badge } from "react-bootstrap";
import NumberFormat from "react-number-format";
import { getIncomingInvoicesDocRef } from "../../../../services/finance/incomingInvoice";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";

function SearchIncomingInvoiceDocRef({ onSelectDocRef }) {
  const { reload } = useGlobalData();
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  useEffect(() => {
    getInvoiceDocRefData();
  }, [reload]);
  return (
    <CustomDataTableSearch
      data={purchaseOrders}
      onRefreshData={() => {
        getInvoiceDocRefData();
      }}
      onSelectedData={(rowData, originalEvent) => {
        onSelectDocRef(rowData);
      }}
      columns={[
        {
          field: "select",
          body: (rowData) => (
            <React.Fragment>
              <button
                type="button"
                className="btn btn-label-success btn-sm btn-pill btn-bold"
                onClick={() => onSelectDocRef(rowData)}
              >
                Select <i className="fas fa-angle-double-right"></i>
              </button>
            </React.Fragment>
          ),
        },
        {
          header: "Purchase Order ID",
          field: "purchaseOrderCode",
          body: null,
          sortable: true,
        },
        {
          header: "Vendor Name",
          field: "vendor.vendorName",
          body: (rowData) => (
            <React.Fragment>
              <ResponsiveEllipsis
                text={rowData.vendor.vendorName}
                maxLine="1"
              />
            </React.Fragment>
          ),
          sortable: true,
        },
        {
          header: "Purchase Date",
          field: "purchaseDate",
          body: (rowData) => formatDate(rowData.purchaseDate),
          sortable: true,
        },
        {
          header: "Goods Receive Status",
          field: "grStatusDesc",
          body: (rowData) => {
            if (rowData.grStatus === 1) {
              return <Badge variant="danger">{rowData.grStatusDesc}</Badge>;
            } else if (rowData.grStatus === 2) {
              return <Badge variant="warning">{rowData.grStatusDesc}</Badge>;
            } else if (rowData.grStatus === 3) {
              return <Badge variant="success">{rowData.grStatusDesc}</Badge>;
            } else {
              return <Badge variant="dark">{rowData.grStatusDesc}</Badge>;
            }
          },
          sortable: true,
        },
        {
          header: "Invoice Status",
          field: "invoiceStatusDesc",
          body: (rowData) => {
            if (rowData.invoiceStatus === 1) {
              return (
                <Badge variant="danger">{rowData.invoiceStatusDesc}</Badge>
              );
            } else if (rowData.invoiceStatus === 2) {
              return (
                <Badge variant="warning">{rowData.invoiceStatusDesc}</Badge>
              );
            } else if (rowData.invoiceStatus === 3) {
              return (
                <Badge variant="success">{rowData.invoiceStatusDesc}</Badge>
              );
            } else {
              return <Badge variant="dark">{rowData.invoiceStatusDesc}</Badge>;
            }
          },
          sortable: true,
        },
        {
          header: "Currency",
          field: "currency.currencyCode",
          body: null,
          sortable: true,
          filter: true,
          hidden: true,
        },
        {
          header: "Grand Total",
          field: "grandTotal",
          body: (rowData) => (
            <NumberFormat
              value={rowData.grandTotal}
              displayType={"text"}
              thousandSeparator={true}
              decimalScale={2}
              renderText={(value) => (
                <div className="float-right">
                  {rowData.currency.currencyCode} {value}
                </div>
              )}
            />
          ),
          sortable: true,
        },
      ]}
    />
  );
  async function getInvoiceDocRefData() {
    const response = await getIncomingInvoicesDocRef();
    const { data } = response.data;
    setPurchaseOrders(data.purchaseOrders);
  }
}

export default SearchIncomingInvoiceDocRef;
